import React from "react";

interface Props {
  onClick?: () => void;
}

function CreateNewTrip(props: Props) {
  return (
    <div className="flex items-center justify-center flex-col">
      <p className="flex text-white font-bold text-4xl md:pl-[32px] md:pr-[32px] text-center">
        {"Your trips and travel plans, in one place"}
      </p>
      <p className="flex text-white font-medium mt-3 text-l md:pl-[32px] md:pr-[32px] text-center">
        {"See the world in your sparetime"}
      </p>
      <button
        id="add-new-trip-button"
        onClick={props.onClick}
        className={`w-[70%] max-w-[320px] rounded-full font-medium mt-10 px-8 py-2.5 text-white dark:text-black transition-colors duration-300 transform bg-black dark:bg-white hover:bg-gray-600 focus:outline-hidden focus:bg-gray-600`}
      >
        {"Add new trip"}
      </button>
    </div>
  );
}

export default CreateNewTrip;
